import React from 'react'
import {useRouter} from 'next/router'

import {createLog} from '@util/logs'

import {useTranslation} from '@lib/intl/useTranslations'
import {useLoginModalStore} from '@store/LoginModalStore'

import {IGlobalNavigationStyles} from '@component/header/GlobalNavigation/GlobalNavigation'

import Text from '@component/Text/Text'
import WizButton from '@component/buttons/WizButton'

interface IProps {
    className?: string
    navStyles?: IGlobalNavigationStyles
    isScrolled?: boolean
}

const NavigationLoginOperation: React.FC<IProps> = ({className, navStyles, isScrolled}) => {
    const t = useTranslation()
    const router = useRouter()
    const showLoginModal = useLoginModalStore(state => state.showLoginModal)

    return (
        <div className={`flex space-x-[10px] items-center truncate ${className}`}>
            <div
                data-cy={'nav_btn_login'}
                className={`${navStyles?.TextSecondaryColor} truncate`}
                onClick={() => {
                    createLog('event', 'navigation_open_login_modal')
                    showLoginModal()
                }}>
                <Text
                    enablePreWhiteSpace={false}
                    className={`cursor-pointer text-[14px] font-bold transition-colors  whitespace-nowrap  ${
                        isScrolled ? 'text-gray01 dark:text-dark_gray01' : navStyles?.TextPrimaryColor
                    }`}>
                    {t('globalNavigation.login')}
                </Text>
            </div>
            <WizButton
                buttonType={'primary'}
                size={'small'}
                text={t('globalNavigation.register')}
                onClick={() => {
                    createLog('event', 'navigation_open_login_modal')
                    showLoginModal()
                }}
                className={`md:hidden  ${navStyles?.buttonPrimaryBackground}`}
                textClassName={`${navStyles?.buttonPrimaryText}`}
            />
        </div>
    )
}
export default NavigationLoginOperation
